import { Mark, getStyleProperty, markInputRule, markPasteRule, mergeAttributes } from "@tiptap/core";
//#region src/highlight.ts
/**
* Matches a highlight to a ==highlight== on input.
*/
const inputRegex = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/;
/**
* Matches a highlight to a ==highlight== on paste.
*/
const pasteRegex = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g;
/**
* This extension allows you to highlight text.
* @see https://www.tiptap.dev/api/marks/highlight
*/
const Highlight = Mark.create({
	name: "highlight",
	addOptions() {
		return {
			multicolor: false,
			HTMLAttributes: {}
		};
	},
	addAttributes() {
		if (!this.options.multicolor) return {};
		return { color: {
			default: null,
			parseHTML: (element) => element.getAttribute("data-color") || getStyleProperty(element, "background-color") || element.style.backgroundColor,
			renderHTML: (attributes) => {
				if (!attributes.color) return {};
				return {
					"data-color": attributes.color,
					style: `background-color: ${attributes.color}; color: inherit`
				};
			}
		} };
	},
	parseHTML() {
		return [{ tag: "mark" }];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"mark",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	renderMarkdown: (node, h) => {
		return `==${h.renderChildren(node)}==`;
	},
	parseMarkdown: (token, h) => {
		return h.applyMark("highlight", h.parseInline(token.tokens || []));
	},
	markdownTokenizer: {
		name: "highlight",
		level: "inline",
		start: (src) => src.indexOf("=="),
		tokenize(src, _, h) {
			const match = /^(==)([^=]+)(==)/.exec(src);
			if (match) {
				const innerContent = match[2].trim();
				const children = h.inlineTokens(innerContent);
				return {
					type: "highlight",
					raw: match[0],
					text: innerContent,
					tokens: children
				};
			}
		}
	},
	addCommands() {
		return {
			setHighlight: (attributes) => ({ commands }) => {
				return commands.setMark(this.name, attributes);
			},
			toggleHighlight: (attributes) => ({ commands }) => {
				return commands.toggleMark(this.name, attributes);
			},
			unsetHighlight: () => ({ commands }) => {
				return commands.unsetMark(this.name);
			}
		};
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-h": () => this.editor.commands.toggleHighlight() };
	},
	addInputRules() {
		return [markInputRule({
			find: inputRegex,
			type: this.type
		})];
	},
	addPasteRules() {
		return [markPasteRule({
			find: pasteRegex,
			type: this.type
		})];
	}
});
//#endregion
//#region src/index.ts
var src_default = Highlight;
//#endregion
export { Highlight, src_default as default, inputRegex, pasteRegex };

//# sourceMappingURL=index.js.map